import styled from 'styled-components';
import sizes from '../../../util/sizes';
import { Title } from '../Title';

export const FeaturedBrandsWrapper = styled.div`
  display: flex;
  column-gap: 100px;
  align-items: center;
  margin-bottom: 120px;
  max-width: ${sizes.XL};

  @media (max-width: ${sizes.XL}) {
    max-width: 100%;
  }

  @media (max-width: ${sizes.L}) {
    max-width: 100%;
    flex-direction: column;
  }
`;

export const FeaturedBrandsHeader = styled(Title)`
  font-weight: 600;
  font-size: 36px;
  color: #263a54;
  margin-top: 0;
  margin-bottom: 0;
  font-family: 'BasierCircle';
  line-height: 46px;
  width: 270px;
  max-width: ${sizes.XL};
  @media (max-width: ${sizes.L}) {
    max-width: 100%;
    text-align: center;
    font-size: 28px;
    margin-bottom: 30px;
    width: initial;
  }
`;

export const FeaturedBrandsInfo = styled.div`
  display: flex;
  width: 800px;
  justify-content: space-around;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 28px;
  align-items: center;
  max-width: ${sizes.XL};

  @media (max-width: ${sizes.L}) {
    margin-top: 30px;
    width: 100%;
    justify-content: space-evenly;
    row-gap: 20px;
    column-gap: 0;
  }
`;

export const ImageContainer = styled.div`
  max-width: ${sizes.XL};
  > span {
    width: fit-content !important;
    img {
      object-fit: contain;
    }
  }
  @media (max-width: ${sizes.S}) {
    > span {
      width: 80% !important;
    }
  }
`;

export const FeaturedBrandsItemInfo = styled.div`
  margin: 24px 28px;
  max-width: ${sizes.XL};

  h4 {
    color: #263a54;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 10px;
    margin-top: 0;
    margin-bottom: 8px;
  }
  > div:nth-child(2) {
    color: #334d70;
    font-size: 17px;
    margin-bottom: 18px;
  }
  > div:last-child {
    color: #1c4d8e;
    font-size: 18px;
    font-weight: 600;
    :after {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-top: 2px solid #1c4d8e;
      border-right: 2px solid #1c4d8e;
      transform: rotate(45deg);
      margin-left: 10px;
    }
  }
`;
